export default function Refrigerator(props: any) {
    return (
        <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_3929_5332)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M41.4399 50.8232H13.8062C13.0341 50.8232 12.3351 50.5436 11.8264 50.0898C11.3152 49.6338 10.998 49.0003 10.998 48.3002V6.09735C10.998 5.41981 11.2949 4.80357 11.7785 4.3508C12.2896 3.87222 13.009 3.57324 13.8062 3.57324H41.4399C42.2874 3.57324 43.0475 3.91094 43.5622 4.44544C43.9895 4.88853 44.248 5.46498 44.248 6.09735V48.3002C44.248 49.0466 43.8866 49.7177 43.3144 50.179C42.8164 50.5791 42.1605 50.8232 41.4399 50.8232Z"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M16.8906 11.0596V14.4479" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16.8906 27.4648V33.4884" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10.6465 21.1899H44.7031" stroke="black" strokeWidth="2" />
            </g>
            <defs>
                <clipPath id="clip0_3929_5332">
                    <rect width="56" height="56" fill="white" transform="translate(0.5 0.0732422)" />
                </clipPath>
            </defs>
        </svg>
    );
}
